import {getRegistrationFormContent} from './registrationFormContent'

// Client-facing wrapper over the server-safe getter in ./registrationFormContent.
// Kept as a hook-named export because it is consumed by ~30 client components.
export const useRegistrationFormContent = () => getRegistrationFormContent()
